import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import  ContractCategories from './HRM/ContractCategories';
import { Header } from './Header';
import { Footer } from './Footer';
import Contract from "./Contract";

export default class Contracts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'contract',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 30,
            phrase: '',
            systemModuleId: 26,
            moduleAccessStatus: 1,
            menuId: 90
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    send(id) {
        this.httpPost("api/v1/contract/send", {
            id: id,
            companyId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("قرارداد جهت تایید با موفقیت به مجری ارسال شد");
                    this.refreshData();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({
            component: <Contract Caller={this} />,
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <Contract Caller={this} Id={id}/>,
        });
    }
    showCategories() {
        this.removeKeyDown();
        this.showComponents({ component: <ContractCategories Caller={this} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);
        
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست قراردادها</h3>
                            <div className="nk-block-des text-soft">
                                <p>شما {this.money(this.state.data.recordsCount)} قرارداد ثبت شده دارید</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-download-cloud"></em><span>افزودن قرارداد جدید</span></a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.showCategories()} className="hand btn btn-warning">
                                                <em className="icon ni ni-list"></em><span>گروه بندی و افزودن مفاد</span>
                                            </a>
                                        </li>
                                        <li>
                                            <NavLink to="/orgunits/" className="btn btn-warning">
                                                <em className="icon ni ni-list"></em><span>واحدهای سازمانی</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/orgposts/" className="btn btn-warning">
                                                <em className="icon ni ni-list"></em><span>پستهای سازمانی</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        {this.state.data.recordsCount <= 0 ?
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>در حال حاضر هیچ قراردادی برای شرکت شما ثبت نشده است</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="card-inner-group">
                                <div className="card-inner position-relative card-tools-toggle">
                                    <div className="card-title-group">
                                        <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                            <div className="form-inline flex-nowrap gx-3">
                                                <div className="form-wrap">
                                                    <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="عنوان واحد سازمانی" className="form-control" />
                                                </div>
                                                <div className="btn-wrap">
                                                    <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                            <div className="nk-tb-col"><span className="sub-text">شماره</span></div>
                                            <div className="nk-tb-col"><span className="sub-text">موضوع</span></div>
                                            <div className="nk-tb-col"><span className="sub-text">نام و نام خانوادگی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ شروع</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ پایان</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{this.genRowNumber(index)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{record.number}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{record.subject}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{record.manCompanyName}</span>
                                                </div>
                                                <div className="nk-tb-col text-center">
                                                    <span className="sub-text">{record.startDate}</span>
                                                </div>
                                                <div className="nk-tb-col text-center">
                                                    <span className="sub-text">{record.finishDate}</span>
                                                </div>
                                                <div className="nk-tb-col text-center">
                                                    {record.status === 1 && <span class="tb-status text-info">پیش نویس</span>}
                                                    {record.status === 2 && <span class="tb-status text-warning">منتظر تایید مجری</span>}
                                                    {record.status === 3 && <span class="tb-status text-danger">پذیرش نشده</span>}
                                                    {record.status === 4 && <span class="tb-status text-success">نهایی شده</span>}
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li className="nk-tb-action-hidden">
                                                            <a onClick={e => this.onEdit(record.id)} className="btn btn-trigger btn-icon" title="مشاهده و ویرایش">
                                                                <em className="icon ni ni-eye-fill"></em>
                                                            </a>
                                                        </li>
                                                        {(record.status === 1 || record.status === 3) &&
                                                            <li className="nk-tb-action-hidden">
                                                                <a className="hand btn btn-trigger btn-icon" onClick={e => this.send(record.id)} title="ارسال جهت تایید به مجری">
                                                                    <em className="icon ni ni-send"></em>
                                                                </a>
                                                            </li>}
                                                        <li className="nk-tb-action-hidden">
                                                            <a className="btn btn-trigger btn-icon hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                                <em className="icon ni ni-cross-fill-c"></em>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        {(record.status === 1 || record.status === 3) && <li><a onClick={e => this.send(record.id)} className="hand"><em className="icon ni ni-send"></em><span>ارسال جهت تایید به مجری</span></a></li>}
                                                                        <li><a onClick={e => this.onEdit(record.id)}><em className="icon ni ni-eye"></em><span>مشاهده و ویرایش</span></a></li>
                                                                        <li><a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-na"></em><span>حذف رکورد</span></a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.createPaging()}
                            </div>
                        }
                    </div>
                </div>
            </div>


        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}